export { 
    showModal,
    showPrivacy, 
    showTerms,
    showMobileMenu,
    sendMail,
    sendMailStarted,
    sendMailSuccess,
    sendMailFailure,
    setTextColor,
    lock,
    unLock,
    setCurrentMainSection
} from './actions'; 


// WEBPACK FOOTER //
// ./client/src/store/actions/index.js